export default __webpack_public_path__ + "static/media/About_Products.7a404eee.png";